<template>
  <div class="hello screen-spacing">
    <div class="">
        <div class="h1 display-inline">Stage List</div>
        <button v-if="venueId!=0 && isBusiness" type="button" ref="action"  class="btn mb-3" data-bs-toggle="modal" data-bs-target="#newStageModal"> <i class="fa-solid fa-plus"></i></button>
    </div>
    <SelectVenue ref="venueDropDown" @updateVenue="updateVenue"/>
    <div class="row mt-4">
        <div v-for="(item,index) in stageList" :key="index" class="card m-3" style="width: 18rem;">
  <div class="card-body">
    <h5 class="card-title mt-1">{{item.name}}</h5>
    <h6 class="card-sub-title text-muted mt-1">{{item.description}}</h6>
    <h6 class="card-sub-title text-muted mt-1">{{item.act_length}}</h6>
    <div class="btn-group" role="group">
       <button v-if="item.is_disabled" v-on:click="toggleEnabled(item)" type="button" class="btn btn-primary mx-1">Disabled</button>
        <button v-if="!item.is_disabled" v-on:click="toggleEnabled(item)" type="button" class="btn btn-primary mx-1">Enabled</button>
        <button v-if="isBusiness" type="button" v-on:click="openModal(item)" class="btn btn-primary mx-1">Edit</button>
        <button v-if="isBusiness" type="button" v-on:click="deleteStage(item._id,index)" class="btn btn-primary mx-1">Delete</button>

        

    </div>
  </div>
  <div class="card-footer text-center border-top bg-white">
      <!-- router-link version -->
      <router-link
        class="btn btn-outline-secondary btn-sm"
        :to="{ name: 'Performer-List', query: { stage_ID: item._id, stageName: item.name } }"
      >
        See current performers
      </router-link>
    </div>
</div>
   </div>
    

<!-- Modal -->
<div class="modal fade" id="newStageModal" ref="modal" tabindex="-1" aria-labelledby="newStageModalLabel" aria-hidden="true">
  <AddNewStage :stage="currentStage" :venueId ="venueId" @addNewStage="addNewStage" @refreshEdit="refreshEdit" @updateStage="updateStage" />
</div>

  </div>
</template>

<script>
//import newMenuItem from "../components/modals/newMenuItem.vue"
import AddNewStage from "../../components/modals/AddNewStage.vue"
import stageService from "../../api/stage.js"
import SelectVenue from "../../components/SelectVenue.vue"
import swal from 'sweetalert';


export default {
  name: 'StageCreation',
  components:{
   AddNewStage,
   SelectVenue
  },
  data() {
    return {
        newItemType:"",
        stageList:[],
        currentStage:"" ,
        venueId:0,
    };
  },
  computed:{
    isBusiness(){
      return sessionStorage.getItem('isBusiness') === "true";
    }
  },
  methods:{
    updateStage(item){
      var updateIndex = this.stageList.findIndex((stage => stage._id === item._id))
      this.stageList[updateIndex].name= item.name
      this.stageList[updateIndex].description= item.description
       swal('Stage has been updated!');
    },
    refreshEdit(){
      this.currentStage=""
    },
    addNewStage(item){
      this.stageList.push(item)
      swal('Your stage has been created!');
    },
    reset(){
      this.stageList=[]
      this.venueId=0
    },
    deleteStage(id,index){
     swal({
    title: 'Are you sure you want to delete this stage?',
    text: 'You won\'t be able to revert this!',
    icon: 'warning',
    buttons: true,
    dangerMode: true,
  }).then((willDelete) => {
    if (willDelete) {
      // If confirmed, show a success message
       stageService.deleteStageID(id)
       this.stageList.splice(index,1)
      swal('Your stage has been deleted!', {
        icon: 'success',
      });
      // TODO: Perform the actual deletion action here
    } else {
      // Handle the cancellation
      swal('Your stage is safe!');
    }
  });
    },
    updateVenue(e){
      if(e.target.value!=0){
        stageService.getAllStages(e.target.value).then(data =>{
        this.stageList = data;
        this.venueId=e.target.value
     })
      }
      else{
        this.reset()
      }
    },
    toggleEnabled(item){
        var toggle = {
          is_disabled:!item.is_disabled
        }
          stageService.updateStageByID(item._id,toggle).then(()=>{
            item.is_disabled=!item.is_disabled
         swal("Stage has been updated!")
          })

    },
    openModal(item){
      this.currentStage=item;     
      this.$refs.action.click();
    },
    getImg(item){
        return item.image
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
